export default class Form_initial {
    constructor() {
        var param = location.search
        if(param === "?partTime"){
            console.log("parttime")
            select("job-2");
        }else if(param === "?career"){
            console.log("career")
            select("job-1");
        }
        function select(targetId){
            const target = document.querySelector("#" + targetId);
            target.checked = true;
        }
    }
}